var map = {
  "./cs.json": [
    "L7",
    [
      "huj"
    ]
  ],
  "./en.json": [
    "kO",
    [
      "io"
    ]
  ],
  "./pl.json": [
    "h3A",
    [
      "ra"
    ]
  ],
  "./ru.json": [
    "qNL",
    [
      "8j"
    ]
  ],
  "./tr.json": [
    "dx",
    [
      "fm"
    ]
  ],
  "./ja.json": [
    "kT",
    [
      "2f"
    ]
  ],
  "./zh.json": [
    "D23",
    [
      "pl"
    ]
  ],
  "./pt-br.json": [
    "zSG",
    [
      59
    ]
  ],
  "./de.json": [
    "IN",
    [
      "ydh"
    ]
  ],
  "./es.json": [
    "ZXH",
    [
      "rpoa"
    ]
  ],
  "./fr.json": [
    "tp",
    [
      "zp"
    ]
  ],
  "./it.json": [
    "Qf",
    [
      "6mt"
    ]
  ],
  "./ko.json": [
    "j9",
    [
      "ph"
    ]
  ],
  "./pt.json": [
    "ed2",
    [
      "ggt"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "TX";
module.exports = __rspack_async_context;
